define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"dojo/when",
	"csi",
	"csi/_base/underscore",
	"csi/expander/Widget",
	"csi/store/Nodes",
	"csi/xml"
], function(declare,lang,when,csi,_,Widget,Nodes,xml) {

	var	QUESTION = "Question",
	SUBSECTION = "QuestionSubsection";

	return declare(Widget, {
		_points: null,
		_questionsByUrl: null,

		_getViewNode: function() {
			var templateNode = this.getViewNode();
			if (!templateNode.hasOwnProperty("TemplateQuestions")) {
				templateNode = this.cacheView.getNode(templateNode.__Parent__);
			}
			return templateNode;
		},

		getPointsPossible: function(/*String*/url) {
			// summary: calculate and cache point totals for every node (OperationsReviewTemplateRevision, ORTSection, QuestionSubsection)
			if (!this._points || (this._points[url] == null)) {
				var	cache = this.cacheView;
				var	rev = this._getViewNode();
				var	sections = cache.getChildren(rev, "Sections");
				var	sectionUrls = csi.hashArray(sections, "TemplateSection", "$URL");
				var	questions = cache.getChildren(rev, "TemplateQuestions");

				var	subsectionPoints = csi.hashArray(questions, "__Parent__", function(q) {
					return cache.getNode(q.CurrentRevision, true).PointsPossible;
				}, null, true);

				var	p = this._points = {};
				var	total = 0;

				_.each(subsectionPoints, function(value, key) {
					var	ss = cache.getNode(key);
					var	sectionUrl = sectionUrls[ss.__Parent__];

					// sum values in array to get subsection total
					p[key] = _.reduce(value, function(memo, num) { return memo + num; }, 0);

					// add value to section
					p[sectionUrl] = (p[sectionUrl] || 0) + p[key];

					// add value to template total
					total += p[key];
				});

				p[rev.$URL] = total;

				// hash questions by url for quick lookup later
				this._questionsByUrl = csi.hashArray(rev.TemplateQuestions, null, Boolean);
			}

			return this._points[url];
		},

		getQuestionsByUrl: function() {
			// summary: return object containing all questions in template by URL
			if (!this._questionsByUrl) {
				this.getPointsPossible(this.getViewURL());
			}

			return this._questionsByUrl;
		},

		onAccessAggregateSubsection: function(/*Context*/ctx, /*Action*/action) {
			// summary: restrict action if all subsections already aggregated
			if (!this.onAccessTemplate(ctx, action)) {
				return false;
			}

			var	orts = ctx.getNode() || this.getViewNode();
			var	section = ctx.cache.getNode(orts.TemplateSection);
			return section.Subsections.length != orts.TemplateSubsections.length;
		},

		onAccessAggregateQuestion: function(/*Context*/ctx, /*Action*/action) {
			// summary: restrict action if all questions already aggregated
			if (!this.onAccessTemplate(ctx, action)) {
				return false;
			}

			var node = ctx.getNode() || this.getViewNode();

			if (!node) return true;

			if(node.$Type == "QuestionSubsection") {
                return !this._isAllSubsectionQuestionsSelected(node);
            }

            var section = ctx.cache.getNode(node.TemplateSection);
            return !_.every(section.Subsections, function(subsection) {
                return this._isAllSubsectionQuestionsSelected(ctx.cache.getNode(subsection));
            }, this);
		},


		onAccessTemplate: function(/*Context*/ctx, /*Action*/action) {
			// summary: allow action if user has edit access on template
			return xml.nodeHasAccess(this._getViewNode(), xml.RIGHT_WRITE, "TemplateQuestions");
		},

		onViewPreferences: function() {
			// summary: post-process view settings after loading custom view
			this.inherited(arguments);

			// if expandLevel set to default, then force expand down to second level
			if (this.expandLevel == 1) {
				this.set("expandLevel", 2);
			}
		},

		postActionQuestions: function(/*Controller*/ac) {
			// summary: reset store so new questions/subsections will be shown
			this.set("store", null);
			return this.postActionRedraw(ac);
		},

		resetPoints: function() {
			// summary: reset points so they will be recalculated again next time rendered
			this._points = null;
			this._questionsByUrl = null;
		},

		_createQueryLevel: function(/*Object*/params, /*Boolean*/bRoot) {
			// summary: special logic to determine if Subsection has Questions in template, and Questions have SubQuestions
			var	ql = this.inherited(arguments);

			if (ql.type == SUBSECTION) {
				ql.hasChildrenTest = lang.hitch(this, this._subsectionHasChildren);
			} else if (ql.type == QUESTION) {
				ql.hasChildrenTest = lang.hitch(this, this._questionHasChildren);
				ql.createCustomStore = lang.hitch(this, this._createQuestionStore);
			}

			return ql;
		},

		_createQuestionStore: function(/*Context*/ctx, /*Boolean?*/bConfigurable) {
			// summary: create Nodes store of questions in template
			if (bConfigurable) {
				return null;
			}

			var	subsectionQuestions = ctx.getNodeAttributeValue("Questions");
			var	questions = csi.transform(subsectionQuestions, function(url) {
				return this[url] ? ctx.cache.getNode(url) : null;
			}, this.getQuestionsByUrl()) || [];

			return new Nodes({
				cachingStore: this.cacheView,
				data: questions
			});
		},

		_isAllSubsectionQuestionsSelected: function(/*Node*/subsection){
			if (!subsection) return false;
			return _.every(subsection.Questions, function(url) {
			    return this[url];
			}, this.getQuestionsByUrl());
		},

		onViewStartBuild: function() {
			// summary: reset points when rendering whole table
			this.resetPoints();
		},

		_questionHasChildren: function(/*Context*/ctx) {
			// summary: special logic to determine if Questions have SubQuestions
		    var revision = ctx.cache.getNode(ctx.getNode().LatestRevision, true);
		    return !!revision.SubQuestions.length;
		},

		_subsectionHasChildren: function(/*Context*/ctx) {
			// summary: special logic to determine if Subsection has Questions in template
			return _.some(ctx.getNode().Questions, function(url) {
				return this[url];
			}, this.getQuestionsByUrl());
		}
	});
});